import { ChangeEvent, FC, FocusEvent } from "react"
import { Integration } from "../../../../../types"
import { useIntegrationSettingsForm } from "../../../../hooks"
import Input from "../../../form/input"

interface Props {
  integration?: Integration
}

const GoogleAnalyticsTag: FC<Props> = ({ integration }) => {
  const { saveSetting, saveSettingLocal, app_settings } =
    useIntegrationSettingsForm(integration)

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    saveSettingLocal({ [e.target.name]: e.target.value, ga_mode: "external" })
  }

  const handleBlur = (e: FocusEvent<HTMLInputElement>) => {
    saveSetting({ [e.target.name]: e.target.value, ga_mode: "external" })
  }

  return (
    <div className="pt-6">
      <Input
        label="Google analytics tag"
        name="ga_tag"
        placeholder="Ex. G-T3BZ6029NZ"
        inputProps={{
          value: app_settings?.settings?.ga_tag ?? "",
          onChange: handleChange,
          onBlur: handleBlur
        }}
      />
    </div>
  )
}

export default GoogleAnalyticsTag
